import React from 'react'

export const AboutMe = () => {
    return (
        <div>
            <h1>Sobre mi</h1>
        </div>
    )
}
